import { metricKeys } from '@pulse/metrics';
import { DEFAULT_METRIC, CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { PRESET_KEYS } from './constants';

export const getValidPresetKeys: any = () => {
  return PRESET_KEYS[CURRENT_PRODUCT_MODE] || {};
};

export const getPresetDefaultMetric = (usecaseKey?: string) => {
  let defaultMetric = DEFAULT_METRIC;
  const PRESET_KEYS = getValidPresetKeys();
  if (usecaseKey === PRESET_KEYS.APP_USER_EXPERIENCE) {
    defaultMetric = metricKeys.AppSubscribers;
  }
  return defaultMetric;
};
